import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import RenameTeamModal from './RenameTeamModal';
import { getAllGroupsInitiate } from '../../../../../actions/groups';

const mapStateToProps = state => {
  const groupsData = _get(state, 'groups', {});

  return {
    groupsData,
    fetchingGroups:
      _get(state, 'apiState.GET_GROUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUPS.isIdle', false),
    fetchedGroups: _get(state, 'apiState.GET_GROUPS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RenameTeamModal);
